module.exports = __webpack_public_path__ + "img/875faea.webp";